import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import UserAccessDashboard from "./UserAccessDashboard";

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {

    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(UserAccessDashboard);
